import { DateWithSession, RenderContext } from '@eventbrite/checkout-fairy-api';
import { parseDate } from '@eventbrite/datetime-fns';

/**
 * Creates a new local date
 * @param  {String} date date string of yyy-MM-d
 */
export const getLocalDate = (date: string) => {
    const { year, month, day } = parseDate(date, 'd', 'MM');
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
};

/**
 * Returns a dateString in the format of yyyy-MM-d
 */
export const getOnlineLocalDate = (date: string, timezone: string) => {
    const utcDate = new Date(date);
    const timezonedDate = new Intl.DateTimeFormat('en-CA', {
        timeZone: timezone,
    }).format(utcDate);
    return timezonedDate;
};

export const updateMonthOnlineLocalDate = (
    month: RenderContext['eventDates'],
    timezone: string,
) =>
    month.reduce((acc: RenderContext['eventDates'], cur: DateWithSession) => {
        cur.sessions.map((session) => {
            // compute the actual date for the session taking in account the user's timezone
            const onlineSessionDate = getOnlineLocalDate(
                session.startDatetime || '',
                timezone,
            );
            // find where in the dates array this session should be in
            const foundDateIndex = acc.findIndex(
                ({ date }) => date === onlineSessionDate,
            );
            // add session to an existing date
            if (foundDateIndex != -1) {
                acc[foundDateIndex].sessions.push(session);
                // create a new date to add the session to
            } else {
                acc.push({
                    date: onlineSessionDate,
                    availability: cur.availability,
                    sessions: [session],
                });
            }
        });
        return acc;
    }, [] as RenderContext['eventDates']);
